import { render, staticRenderFns } from "./auditInvoice.vue?vue&type=template&id=388b5b6a&scoped=true"
import script from "./auditInvoice.vue?vue&type=script&lang=js"
export * from "./auditInvoice.vue?vue&type=script&lang=js"
import style0 from "./auditInvoice.vue?vue&type=style&index=0&id=388b5b6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388b5b6a",
  null
  
)

export default component.exports